import React from 'react'
import { BackButton, IconContainer } from './styles'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography } from 'src/components'
import Back from 'src/assets/Icons/Back'
import { useTranslations } from 'src/provider/LocaleProvider'

export const Index = () => {
    const navigate = useNavigate()
    const t = useTranslations()
    const handleBack = useCallback(() => {
        navigate(-1)
    }, [navigate])
    return (
        <BackButton onClick={handleBack}>
            <IconContainer>
                <Back />
            </IconContainer>
            <Typography>{t('cta.goBack')}</Typography>
        </BackButton>
    )
}

export default Index
